import Vue from "vue";
import Vuex from "vuex";
import nhf from './module/nhf'
import formula from './module/formula'
import estimate from './module/estimate'
import economy from "./module/economy"
import material from './module/material'
import home from './module/home'
import procedure from './module/procedure'
import product from './module/product'
import news from './module/news'
import empirical from './module/empirical';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    menuInfor: {
      first: {},
      second: {},
      third: {},
      hierarchy: 0,
    },
    loading: false, // 请求loading
    userName: "",
    factoryName: "",
    layout: {
      showSider: true,
      showRight: true,
      layoutType: false,
    },
    precision: {
      nutritionAnalysisVal:4,
      nutritionValue:4,
      baseNutritionVal:4,
      culationValue:4
    } // 小数精度
    
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    },
  },
  mutations: {
    saveMenuInformation(state, data) {
      // 点击菜单保存点击信息
      state.menuInfor.hierarchy = data.hierarchy;
      if (data.hierarchy === 1) {
        state.menuInfor.first = { name: data.name, path: data.path };
        state.menuInfor.second = {};
        state.menuInfor.third = {};
      } else if (data.hierarchy === 2) {
        state.menuInfor.second = { name: data.name, path: data.path };
        state.menuInfor.third = {};
      } else if (data.hierarchy === 3) {
        state.menuInfor.third = { name: data.name, path: data.path };
      }
    },
    controlLoading(state, flag) {
      state.loading = flag;
    },
    saveUserName(state, data) {
      state.userName = data.userName;
    },
    saveFactoryName(state, data) {
      state.factoryName = data.factoryName;
    },
  },
  modules:{
    nhf,
    formula,
    estimate,
    economy,
    material,
    home,
    procedure,
    product,
    news,
    empirical
  }
});

export default store;
